import Mutations from '../../odata/mutations';

export default { ...new Mutations('person'), ...new Mutations('people'), ...new Mutations('search') };
